export default __webpack_public_path__ + "static/media/Wrong_SFX.355a1303.mov";